/**
 * Port of {@class EnumValueProvider} —
 * backend/src/main/java/com/irian/iam/ruleengine/api/EnumValueProvider.java
 *
 * Looks up the active codes for an enum type table.
 */

export type EnumValueProvider = {
    /**
     * Returns the active codes for the named enum type, in the order the
     * type table emits them. Inactive entries are filtered out by the
     * implementation.
     */
    activeCodes(enumTypeName: string): readonly string[]
}

/**
 * No-op provider that registers no values for any type. Used by parser paths
 * that do not have a database-backed type registry.
 */
export const EMPTY_ENUM_VALUE_PROVIDER: EnumValueProvider = {
    activeCodes(): readonly string[] {
        return []
    },
}
